import * as React from 'react';
import { DAYS_OF_WEEK } from '../../../../consts/common';

export function DaysOfWeekBar() {
  return (
    <div className="cal-dow">
      {DAYS_OF_WEEK.map((dayOfWeek, index) => (
        <div className="cal-dow__c" key={`day_of_week_${index}`}>
          {String(dayOfWeek).slice(0, 3)}
        </div>
      ))}
    </div>
  );
}